var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "上传授权书",
        visible: _vm.visible,
        centered: true,
        width: 600,
        "confirm-loading": _vm.confirmLoading
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c("div", { staticClass: "answer-box-h3" }, [_vm._v("上传授权书步骤")]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "auth-step" },
        _vm._l(_vm.steps, function(item, index) {
          return _c("li", { key: index }, [
            _c("img", { attrs: { src: item.img, alt: "" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(item.label))])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "a-spin",
        { attrs: { spinning: _vm.spinning, size: "large" } },
        [
          _c("form-create", {
            staticClass: "form-create form-create-new",
            attrs: { rule: _vm.rule, option: _vm.option },
            model: {
              value: _vm.fApi,
              callback: function($$v) {
                _vm.fApi = $$v
              },
              expression: "fApi"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22a78a34", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22a78a34","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/uploadAuthorizationLetter.vue
// module id = null
// module chunks = 